const getters = {
    carNumberHistory: state => state.carpark.carNumberHistory,
    carNumberDefault: state => state.carpark.carNumberDefault,
    setCarDefault: state => state.carpark.setCarDefault,
    initCarState: state => state.carpark.initCarState
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js